//Import Required Libraries
import * as d3 from 'd3';

//Define required colors
let barColor = '#687176';
let showColor = '#8CC453';
let hideColor = '#A52C22';

const getCustomExtent = (data, colName) => {
    let min = d3.min(data, d => d[colName]) - 5;
    let max = d3.max(data, d => d[colName]) + 5;
    let extent = [min < 0 || data.length === 1 ? 0 : min, max]
    return extent;
}

export const makePieChart = (data, filter, setFilter) => {

    let myobj = document.getElementById("total-pie");
    if (myobj) {
        myobj.remove();
    } 
    // set the dimensions and margins of the graph
    let width = 200,
        height = 200,
        margin = 40

    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
    let radius = Math.min(width, height) / 2 - margin
    let cornerRadius = 5;

    // append the svg object to the div called 'my_dataviz'
    let svg = d3.select("#total-pie-container")
                .append('div')
                .attr('id', 'total-pie')
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    // Create dummy data
    // let data = {a: 9, b: 20, c:30, d:8, e:12}

    // set the color scale
    let color = d3.scaleOrdinal()
                    .domain(data)
                    .range([showColor, hideColor])

    // Compute the position of each group on the pie:
    let pie = d3.pie().value(function(d) {return d.value; })
    let data_ready = pie(d3.entries(data))

    // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
    svg.selectAll('whatever')
        .data(data_ready)
        .enter()
        .append('path')
        .attr('d', d3.arc()
                    .innerRadius(30)
                    .outerRadius(radius)
                    .cornerRadius(cornerRadius)
        )
        .attr('fill', function(d){ return(color(d.data.key)) })
        .attr("stroke", "white")
        .style("stroke-width", "2px")
        .style("opacity", 0.85)
        .on('mouseover', function(d) {
            d3.select(this).style('opacity', 1);
            d3.select(this).style('cursor', 'pointer');
        })
        .on('mouseout', function(d) {
            d3.select(this).style('opacity', 0.85);
        })
        .on('click', function(d) {
            let filterValue = filter.showAll !== 'all' ? 'all' : d.data.key;
            setFilter({...filter, showAll: filterValue});
        })
}

export const makeYearBar = (data, filter, setFilter) => {

    let myobj = document.getElementById("year-bar");
    if (myobj) {
        myobj.remove();
    } 

    // set the dimensions and margins of the graph
    let margin = {top: 20, right: 10, bottom: 40, left: 30},
        width = 300 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom;

    // append the svg object to the div called 'my_dataviz'
    let svg = d3.select("#year-bar-container")
                .append('div')
                    .attr('id', 'year-bar')
                .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                .append("g")
                    .attr("transform", `translate(${margin.left}, ${margin.top})`)

    // X axis
    var x = d3.scaleBand()
                .range([ 0, width ])
                .domain(data.map(d => d.year))
                .padding(0.2);

    svg.append("g")
            .attr("transform", `translate(0, ${height})`)
        .call(d3.axisBottom(x).tickSize(0))
        .selectAll("text")
            .attr("transform", "translate(-10,0)rotate(-45)")
            .style("text-anchor", "end")
            .attr('id', d => `yearLabel_${d}`);

    // Add Y axis
    let y = d3.scaleLinear()
                 .domain(getCustomExtent(data, 'count'))
                .range([ height, 0]);
    svg.append("g")
        .call(d3.axisLeft(y));

    //Bars
    svg.selectAll("myRect")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", d => x(d.year))
        .attr("y", d => y(d.count))
        .attr("width", x.bandwidth())
        .attr("height", d => height-y(d.count))
        .attr("fill", barColor)
        .attr('opacity', 0.7)
        .on('click', function(d) {
            setFilter({
                ...filter,
                year: filter.year ? null : d.year
            })
        })
        .on('mouseover', function(d) {
            d3.select(this).style('opacity', 1);
            d3.select(this).style("cursor", "pointer");
            d3.select(`#yearLabel_${d['year']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('fill', barColor);
            d3.select(`#yearValue_${d['year']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('fill', barColor);

        })
        .on('mouseout', function(d) {
            d3.select(this).style('opacity', 0.7);
            d3.select(`#yearLabel_${d['year']}`)
                .style('font-size', 10)
                .style('font-weight', 100)
                .style('fill', 'black');
            d3.select(`#yearValue_${d['year']}`)
                .style('font-size', 10)
                .style('font-weight', 100)
                .style('fill', 'black');
                
        })

    svg.append("g")
        .attr("id", "gYearLabel")
        .attr("transform", `translate(0,0)`)
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
        .attr("x", (d) => x(d.year) + (x.bandwidth()/2))
        .attr("y", (d) => y(parseInt(d.count)) - 3)
        .attr("fill", "black")
        .attr("text-anchor", "middle")
        .attr("font-size", "10px")
        .attr("font-weight", "100")
        .text((d) => d.count)
        .attr('id', d => `yearValue_${d.year}`)
}

export const makeCategoryBar = (data, filter, setFilter) => {

    //filter out categories all & home
    // data = data.filter(obj => obj.categories !== 'all' && obj.categories !== 'home');
    data = data.filter(obj => obj.categories !== 'all');

    //sort desc based on count
    data = data.slice().sort((a, b) => d3.descending(a.count, b.count))

    let myobj = document.getElementById("category-bar");
    if (myobj) {
        myobj.remove();
    } 

    // set the dimensions and margins of the graph
    let margin = {top: 0, right: 25, bottom: 0, left: 110},
        width = 460 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom;

    // append the svg object to the div called 'my_dataviz'
    let svg = d3.select("#category-bar-container")
                .append('div')
                    .attr('id', 'category-bar')
                .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                .append("g")
                    .attr("transform", `translate(${margin.left}, ${margin.top})`)

    // Add X axis
    var x = d3.scaleLinear()
                .domain(getCustomExtent(data, 'count'))
                .range([ 0, width ]);
    
    // Y axis
    var y = d3.scaleBand()
                .range([ 0, height ])
                .domain(data.map(d => d.categories))
                .padding(.1);

    // Y-Count axis
    var yCount = d3.scaleBand()
                .range([ 0, height ])
                .domain(data.map(d => d.categories))
                .padding(.1);

    //Bars
    svg.selectAll("myRect")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", x(0))
        .attr("y", d => y(d.categories))
        .attr("width", d => x(d.count))
        .attr("height", y.bandwidth())
        .attr("fill", barColor)
        .attr('opacity', 0.7)
        .on('click', function(d) {
            setFilter({
                ...filter,
                categories: filter.categories ? null : d.categories
            })
        })
        .on('mouseover', function(d) {
            d3.select(this).style('opacity', 1);
            d3.select(this).style("cursor", "pointer");
            d3.select(`#catLabel_${d['categories']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('fill', barColor);
            d3.select(`#catValue_${d['categories']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('fill', barColor);

        })
        .on('mouseout', function(d) {
            d3.select(this).style('opacity', 0.7);
            d3.select(`#catLabel_${d['categories']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('font-size', 10)
                .style('font-weight', 100)
                .style('fill', 'black');
            d3.select(`#catValue_${d['categories']}`)
                .style('font-size', 16)
                .style('font-weight', 600)
                .style('font-size', 10)
                .style('font-weight', 100)
                .style('fill', 'black');
                
        })

    //Drawing axis
    svg.append("g")
            .attr("transform", `translate(-5,0)`)
        .call(d3.axisLeft(y).tickSize(0))
        .call(g => g.select(".domain").remove())
        .selectAll("text")
            .style("text-transform", "capitalize")
            .style("text-anchor", "end")
            .attr('id', d => `catLabel_${d}`)
            .style('font-size', 10)
            .style('font-weight', 100);

    svg.append("g")
            .attr("transform", `translate(${width-margin.right+20},0)`)
        .call(d3.axisRight(yCount).tickSize(0))
        .call(g => g.select(".domain").remove())
        .selectAll("text")
            .text((d, i) => data[i].count)
            .attr('id', d => `catValue_${d}`)
            .style('font-size', 10)
            .style('font-weight', 100);
}